import { observer } from 'mobx-react-lite'
import { CardsFilter } from 'shared/ui'
import { useClickToTextDetailsContext } from 'pages/clickToText/pages/viewClickToText/context'
import styles from './styles.module.scss'

export const ClickToTextStatisticsFilter = observer(() => {
  const { filters, onActiveFilter, filter } = useClickToTextDetailsContext()

  if (!filters) return null

  return (
    <>
      <CardsFilter
        items={filters}
        activeKey={filter}
        onActiveFilter={onActiveFilter}
        wrapperClassName={styles.filterWrapper}
      />
      <div className={styles.separator} />
    </>
  )
})
